/* eslint-disable no-unused-vars */

import { st } from "../../constants/styles";
import SectionTitle from "../UI/SectionTitle";

const SectionMyAccount = ({ user, loading, isError }) => {
  //   const { user: USER, isLoading, isError } = useCurrentUser();
  if (loading) return <p>Loading...</p>;
  if (isError || !user) return <p>Please log in.</p>;

  return (
    <div>
      <SectionTitle
        title="Account Overview"
        subtitle={`Welcome back, ${user?.firstName}${user?.lastName}!`}
      />

      {/* content */}
      <div className="row g-3 mb-28">
        {[
          { num: "_", label: "Total Orders" },
          { num: "_", label: "Delivered" },
          { num: "_", label: "Wishlist Items" },
          { num: "_", label: "Saved Addresses" },
        ].map(({ num, label }) => (
          <div className="col-6 col-md-3" key={label}>
            <div style={st.summaryBox}>
              <div style={st.summaryNum}>{num}</div>
              <div style={st.summaryLabel}>{label}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={st.divider} />

      <p style={{ ...st.sectionTitle, fontSize: 15, marginBottom: 16 }}>
        Personal Information
      </p>
      <div className="row g-3">
        {[
          {
            label: "Username",
            value: `${user?.firstName}${user?.lastName}` || "—",
          },
          { label: "Email Address", value: user.email || "—" },
          { label: "Phone Number", value: user.phoneNumber || "—" },
          { label: "Role", value: user.roles?.join(", ") || "—" },
          { label: "Address Line 1", value: user.address?.addressLine1 || "—" },
          { label: "Address Line 2", value: user.address?.addressLine2 || "—" },
        ].map(({ label, value }) => (
          <div className="col-sm-6" key={label}>
            <p style={st.labelText}>{label}</p>
            <p style={st.valueText}>{value}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionMyAccount;
